import React, { ReactElement } from "react";

import { StyledContainer, StyledHeader, StyledImg } from "./style";

interface NotFoundContentProps {
  header: string;
  paragraph?: string | ReactElement | undefined | null;
  imageSrc: string;
  imageAlt: string;
}

const NotFoundContent = ({ header, paragraph = null, imageSrc, imageAlt }: NotFoundContentProps) => (
  <StyledContainer>
    <StyledHeader>{header}</StyledHeader>
    {!!paragraph && paragraph}
    <StyledImg src={imageSrc} alt={imageAlt} />
  </StyledContainer>
);

export default NotFoundContent;
